"use client";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { useState } from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import CarouselImageButtons from "./CarouselImageButtons";
import CarouselImageItem from "./CarouselImageItem";

import styles from "./CarouselImage.module.scss";

export type CarouselImageType = {
  url: string;
  id?: string;
  alt?: string;
};

interface Props {
  images: CarouselImageType[];
  autoPlay?: boolean;
  imageClassName: string;
  navButtonsAlwaysVisible?: boolean;
  imageCountNoIndicators?: number;
  animation?: "fade" | "slide";
  quality?: number;
  width?: number;
  index?: number;
  bgResponsive?: boolean;
  imageOnClick?: (index?: number) => void;
  objectFit?: "contain" | "cover";
}

function CarouselImage({ index, images, autoPlay, imageClassName, quality, width, bgResponsive, objectFit, imageOnClick }: Props) {
  const [beginOrEnd, setBeginOrEnd] = useState<"begin" | "end" | undefined>(undefined);
  const [swiper, setSwiper] = useState<any>(null);

  /**
   * Swiper uses class name to add required onClick for prev/next functionality
   * Set the max number of results (todo: move this to CMS global web config)
   */
  const [prevButton] = useState<string>("card-scroll-prev_CarouselImage");
  const [nextButton] = useState<string>("card-scroll-next_CarouselImage");

  function handleOnImageItemClick() {
    if (typeof imageOnClick === "function") {
      imageOnClick(swiper?.activeIndex);
    }
  }

  return (
    <>
      <CarouselImageButtons
        prevClassName={prevButton}
        nextClassName={nextButton}
        beginOrEnd={beginOrEnd}
        classes={{
          prevClassName: styles.buttonPrev,
          nextClassName: styles.buttonNext,
        }}
      />
      <Swiper
        autoplay={autoPlay}
        modules={[Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        onSlideChange={() => {
          if (beginOrEnd) {
            setBeginOrEnd(undefined);
          }
        }}
        onSwiper={setSwiper}
        loop={true}
        direction="horizontal"
        initialSlide={index ?? 0}
        onReachBeginning={() => setBeginOrEnd("begin")}
        onReachEnd={() => setBeginOrEnd("end")}
        navigation={{
          prevEl: `#${prevButton}`,
          nextEl: `#${nextButton}`,
        }}
      >
        {(images ?? []).map((item, i) => (
          <SwiperSlide
            key={i}
            className={styles.card}
          >
            <CarouselImageItem
              key={i}
              url={item.url}
              alt={item.alt}
              id={item.url}
              imageClassName={imageClassName}
              quality={quality}
              width={width}
              bgResponsive={bgResponsive}
              objectFit={objectFit}
              imageOnClick={handleOnImageItemClick}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default CarouselImage;
